<fui-canvas>
    <fui-canvas-overlay></fui-canvas-overlay>
    <ng-content select="fui-canvas-masthead"></ng-content>
    <ng-content select="fui-canvas-window"></ng-content>
</fui-canvas>
<fui-injectables></fui-injectables>
